import cx from "classnames";
import { AnchorHTMLAttributes, DetailedHTMLProps } from "react";

const getAlternativeColors = (alternative: Alternative) =>
  alternative === "primary"
    ? "bg-yellow has-hover:hover:text-white has-hover:hover:bg-cornflower-blue active:text-white active:bg-cornflower-blue"
    : "bg-white";

export type Alternative = "primary" | "secondary";

type PushableButtonLinkProps = DetailedHTMLProps<
  AnchorHTMLAttributes<HTMLAnchorElement>,
  HTMLAnchorElement
> & { alternative?: Alternative };

export const PushableButtonLink = ({
  className,
  alternative = "primary",
  ...props
}: PushableButtonLinkProps) => (
  <a
    className={cx(
      getAlternativeColors(alternative),
      "transition-all py-2.5 px-6 rounded-full border border-black border-solid relative drop-shadow-black",
      "active:drop-shadow-none active:translate-x-1 active:translate-y-1",
      className,
    )}
    {...props}
  />
);
